// extracted by mini-css-extract-plugin
export default {"offCanvasHeader":"style_offCanvasHeader__6ZSRP","logTable":"style_logTable__Fk32t"};